import React from 'react';
import PropTypes from 'prop-types';

import { Switch } from '@metarouter-private/mr-mui';
import { useUpdatePlaybookDisabled, isPlaybookDisabled } from '@ion/api';
import isAllowedToUpdateIntegration from '@ion/api/integrations/permissions/isAllowedToUpdateIntegration';

import WithTooltip from 'app/components/WithTooltip';

export default function RevisionEnabledSwitch({ playbook, onClick }) {
  const [updatePlaybookDisabled, { loading }] = useUpdatePlaybookDisabled();

  const isDisabled = isPlaybookDisabled(playbook);

  const handleChange = () => {
    if (isDisabled) {
      updatePlaybookDisabled({ playbookId: playbook.id, disabled: false });
      return;
    }
    onClick();
  };

  return (
    <WithTooltip show title={isDisabled ? 'Enable revision for deployment' : 'Disable revision from deployment'}>
      <Switch
        size="small"
        checked={!isDisabled}
        onChange={handleChange}
        disabled={!isAllowedToUpdateIntegration() || loading}
        data-test-id="revisionEnabledSwitch"
      />
    </WithTooltip>
  );
}

RevisionEnabledSwitch.propTypes = {
  playbook: PropTypes.shape({
    id: PropTypes.string.isRequired,
    disabledAt: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};
